module.exports = __webpack_public_path__ + "static/media/noun-done-1195562-FFFFFF.c0f2fb4c.svg";